import axios from 'axios';

const verifyOwnership = (accessToken, loanId) => {
  const data = { loanId };
  return axios({ method: 'post', url: '/banking/api/v1/mortgages/link', headers: getHeader(accessToken), data });
};

const getHeader = (accessToken) => {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` };
};

export { verifyOwnership };
